import { render, staticRenderFns } from "./settlementBatchModifyState.vue?vue&type=template&id=81b23b2a&scoped=true"
import script from "./settlementBatchModifyState.vue?vue&type=script&lang=ts"
export * from "./settlementBatchModifyState.vue?vue&type=script&lang=ts"
import style0 from "./settlementBatchModifyState.vue?vue&type=style&index=0&id=81b23b2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b23b2a",
  null
  
)

export default component.exports